import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import useSWR from 'swr'
import { Button, ConfigProvider, Empty, Typography } from 'antd'
import { ExceptionOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons'
import PageLayout from '@BUP/components/Layout/Page'
import { getFetcher } from '@BUP/services/Axios'
import { ComplaintList } from '@BUP/components/complaint/list'
import { useState } from 'react'
import { HelpDrawer } from '@BUP/components/Generics/help-drawer.jsx'
import { PageHeaderWithHelpIcon } from '@BUP/components/Generics/page-header-with-help-icon.jsx'

function NewComplaintButton ({ ...props }) {
  const history = useHistory()
  const handleOnClick = () => history.push('/logbook/complaints/new')
  return <Button type='primary' icon={<PlusOutlined />} onClick={handleOnClick} {...props} />
}

function ComplaintsSection () {
  const i18n = useTranslation()
  const { data, isLoading, isValidating, error, mutate } = useSWR('/current-organization/complaints?include=complaintEntries', getFetcher, {
    errorRetryCount: 3,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  })
  const [open, setOpen] = useState(false)
  const showDrawer = () => setOpen(true)
  const closeDrawer = () => setOpen(false)

  const errorRenderEmpty = () => (
    <Empty description={i18n.t('common.resources.generic.actions.any.failure')} image={<ExceptionOutlined style={{ fontSize: 96 }} />}>
      <Button icon={<ReloadOutlined />} onClick={() => mutate()}>{i18n.t('common.resources.generic.actions.any.try-again')}</Button>
    </Empty>
  )

  const customizeRenderEmpty = () => (
    <Empty description={i18n.t('common.resources.complaint.label', { count: 0 })}>
      <NewComplaintButton>{i18n.t('pages.logbook.new.label', { context: 'first' })}</NewComplaintButton>
    </Empty>
  )

  return (
    <ConfigProvider renderEmpty={error ? errorRenderEmpty : customizeRenderEmpty}>
      <PageHeaderWithHelpIcon title={i18n.t('pages.logbook.index.title')} titleLevel={2} iconOnClick={showDrawer} />
      <ComplaintList
        complaints={data || []}
        header={data?.length > 0 && <NewComplaintButton>{i18n.t('pages.logbook.new.label')}</NewComplaintButton>}
        loading={isLoading || isValidating}
      />
      <HelpDrawer prefix='pages.logbook.index' title={i18n.t('pages.logbook.index.title')} open={open} onClose={closeDrawer} />
    </ConfigProvider>
  )
}

export function LogbookPage () {
  const i18n = useTranslation()
  const [open, setOpen] = useState(false)
  const showDrawer = () => setOpen(true)
  const closeDrawer = () => setOpen(false)

  return (
    <PageLayout>
      <PageHeaderWithHelpIcon title={i18n.t('pages.logbook.title')} titleLevel={1} iconOnClick={showDrawer} />
      {i18n.t('pages.logbook.description', { returnObjects: true }).map((text, index) => <Typography.Paragraph type='secondary' key={index}>{text}</Typography.Paragraph>)}
      <ComplaintsSection />
      <HelpDrawer prefix='pages.logbook' title={i18n.t('pages.logbook.title')} open={open} onClose={closeDrawer} />
    </PageLayout>
  )
}
